import {combineReducers} from 'redux';
import { authReducer } from "./authReducer";
import { clientReducer } from './clientReducer';
import { paymentReducer } from './paymentReducer';
import { formsReducer } from './formsReducer';
import { roomReducer } from './roomReducer';
import {modalReducer} from './modalReducer';

export const rootReducer=combineReducers({
    auth: authReducer,
    client: clientReducer,
    payments: paymentReducer,
    forms: formsReducer,
    rooms: roomReducer,
    modal: modalReducer,
})